import axios from "axios";

export const login = ({ email, password }) => {
  return axios.post("/users/auth/login/", {
    email: email,
    password: password,
  });
};
